// src/hooks/useNotificationPermission.js
import { useState } from 'react';
import { requestNotificationPermission } from '../services/NotificationService';

// Shared permission/token state machine used by both the customer
// (NotificationPermissionButton) and admin (AdminNotificationButton) UIs.
// Reflects and drives the browser's actual Notification.permission state
// rather than tracking its own separate flag.
export const useNotificationPermission = ({ userId, saveToken }) => {
  const [status, setStatus] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'unsupported'
  );
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const enable = async () => {
    setBusy(true);
    setError(null);
    try {
      const result = await requestNotificationPermission();
      setStatus(result.status);

      if (result.status === 'granted' && result.token && userId) {
        await saveToken(userId, result.token);
      }

      return result.status;
    } catch (err) {
      console.error('Error enabling notifications:', err);
      setError('Something went wrong enabling notifications. Please try again.');
      return 'error';
    } finally {
      setBusy(false);
    }
  };

  return { status, busy, error, enable };
};
